import React from 'react';
import { Col, Row, Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import useConsultantRole from '../hooks/useConsultantRole';
const ConsultantsWithAccess = _ref => {
  let {
    consultants = [],
    removeConsultantFromClaim,
    size = 'sm',
    isUnderReview,
    canRemoveConsultant
  } = _ref;
  const [getConsultantRole] = useConsultantRole();
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    md: 12
  }, /*#__PURE__*/React.createElement("h4", null, t('consultants'))), consultants.sort((a, b) => a.name.localeCompare(b.name)).filter(c => c.to_delete !== false).map(consultant => /*#__PURE__*/React.createElement(React.Fragment, {
    key: consultant.id
  }, /*#__PURE__*/React.createElement(Col, {
    md: {
      span: size === 'lg' ? 4 : 2,
      offset: size === 'lg' ? 2 : 1
    }
  }, /*#__PURE__*/React.createElement("p", null, "- ", consultant.name, " ")), /*#__PURE__*/React.createElement(Col, {
    md: {
      span: size === 'lg' ? 4 : 2
    }
  }, /*#__PURE__*/React.createElement("p", null, "- ", t(getConsultantRole(consultant.role)), " ")), /*#__PURE__*/React.createElement(Col, {
    md: {
      span: size === 'lg' ? 2 : 5
    }
  }, canRemoveConsultant && /*#__PURE__*/React.createElement(Button, {
    size: 'sm',
    disabled: isUnderReview,
    onClick: e => removeConsultantFromClaim(consultant),
    variant: "danger",
    className: "text-white"
  }, /*#__PURE__*/React.createElement("span", {
    className: "material-icons md-18"
  }, "delete"))))));
};
export default ConsultantsWithAccess;